/* global angular */
( function () {
	'use strict';

	function pdfTemplateEvidence ( moment, pdfRtfParserObs ) {
		function buildTextEvidence ( evidence ) {
			var textObj = {
				'text'  : evidence.name,
				'style' : 'evidence'
			};

			var imageObj = {
				'image'  : 'text.jpg',
				'width'  : 10,
				'margin' : [ 0, 12, 0, 0 ]
			};

			return {
				'columns' : [ imageObj, textObj ]
			};
		}

		function buildScriptEvidence ( evidence ) {
			var textObj = {
				'text'  : moment( evidence.timestamp ).format( 'MM/DD/YY hh:mm A' ) + ' - ' + evidence.name,
				'style' : 'evidence'
			};

			var imageObj = {
				'image'  : 'script.jpg',
				'width'  : 10,
				'margin' : [ 0, 12, 0, 0 ]
			};

			return {
				'columns' : [ imageObj, textObj ]
			};
		}

		function buildCounterEvidence ( evidence ) {
			var textObj = {
				'text'  : evidence.description + ' - ' + evidence.name,
				'style' : 'evidence'
			};

			var imageObj = {
				'image'  : 'counter.jpg',
				'width'  : 12,
				'margin' : [ 0, 12, 0, 0 ]
			};

			return {
				'columns' : [ imageObj, textObj ]
			};
		}

		function buildTimerEvidence ( evidence ) {
			var textObj = {
				'text'  : evidence.description + ' - ' + evidence.name,
				'style' : 'evidence'
			};

			var imageObj = {
				'image'  : 'timer.jpg',
				'width'  : 12,
				'margin' : [ 0, 12, 0, 0 ]
			};

			return {
				'columns' : [ imageObj, textObj ],
				'margin'  : [ 0, -15, 0, 0 ]
			};
		}

		function buildFileEvidence ( evidence ) {
			var textObj = {
				'text'  : evidence.description + ' - ' + evidence.name,
				'style' : 'evidence'
			};

			var imageObj = {
				'image'  : 'file.jpg',
				'width'  : 12,
				'margin' : [ 0, 12, 0, 0 ]
			};

			return {
				'columns' : [ imageObj, textObj ],
				'margin'  : [ 0, -15, 0, 0 ]
			};
		}

		var evidenceTypeBuilder = {
			'3' : buildFileEvidence,
			'4' : buildTextEvidence,
			'5' : buildFileEvidence,
			'6' : buildCounterEvidence,
			'7' : buildTimerEvidence,
			'8' : buildScriptEvidence
		};

		function generateEvidence ( observation, masterList ) {
			function mapEvidences ( evidence ) {
				return [ ( evidenceTypeBuilder[ masterList[ evidence ].type ] || angular.noop )( masterList[ evidence ] ) || {} ];
			}

			return ( observation.evidences || [] ).map( mapEvidences );
		}

		function attachEvidence ( observation, masterList, isTemplate, isSection ) {
			var tableStyle = [ 'indicatorEvidence', 'sectionEvidence' ];
			var index      = Number( Boolean( isSection ) ) + Number( Boolean( isTemplate ) );

			var evidenceTitle = [ {
				'stack' : pdfRtfParserObs.parse( observation.name || observation.questionText ) || '',
				'style' : 'evidenceTitle'
			} ];

			var evidenceLabel = {
				'text'     : 'Evidence:',
				'fontSize' : 9
			};

			evidenceTitle.unshift( evidenceLabel );
			return {
				'style' : tableStyle[ index ],
				'table' : {
					'body'   : [ [ [].concat.apply( evidenceTitle, generateEvidence( observation, masterList ) ) ] ],
					'widths' : [ '*' ]
				},

				'layout' : 'noBorders'
			};
		}

		return attachEvidence;
	}

	pdfTemplateEvidence.$inject = [ 'moment', 'pdfRtfParserObs' ];

	angular
		.module( 'app.components' )
		.factory( 'pdfTemplateEvidence', pdfTemplateEvidence );
} )();
